export default __webpack_public_path__ + "images/273dadf7ef1838883536221451dce404-calm-mind.svg";